import { useEffect } from 'react';

import { useSetAtom } from 'jotai';

import { getVisitorConfigsAPI } from 'src/stores/visitor/apis';
import { visitorConfigAtom } from 'src/stores/visitor/atoms';
import { EVENT_NAME, EVENT_TYPE } from 'src/types/Event';
import { pushEvent } from 'src/utils/event-gateway';

const useGetVisitorConfigs = () => {
  const setVisitorConfigs = useSetAtom(visitorConfigAtom);
  useEffect(() => {
    getVisitorConfigsAPI().then((res) => {
      const visitorConfigs = res.data.configs;
      setVisitorConfigs(visitorConfigs);
      pushEvent({
        eventType: EVENT_TYPE.VISITOR,
        eventName: EVENT_NAME.VISITOR_CONFIG,
        eventParams: visitorConfigs,
      });
    });
  }, [setVisitorConfigs]);
};

export default useGetVisitorConfigs;
